export default __webpack_public_path__ + "static/media/11.03e91ec8.jpg";